angular
    .module('app.controllers')
    .controller('EditInterestCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, notify, api, formValidator, UserService, variables) {
        // dane
        const InterestModel = api('interests');

        $scope.clientOptions = [];
        $scope.projectOptions = [];

        $scope.interest = {};
        if (0 < $stateParams.id) {
            const info = notify.info($translate.instant('loading'));
            InterestModel.get($stateParams.id).then((response) => {
                $scope.interest = response;

                $scope.clientOptions = [
                    {
                        id: $scope.interest.client_id,
                        name: $scope.interest.client.name,
                    },
                ];

                info.close();
                notify.success($translate.instant('loaded'));
                $rootScope.$broadcast('edit-panel-ready');
            });
        } else {
            $scope.interest = {
                id: 0,
                author_id: UserService.getUser().id,
                owner_id: UserService.getUser().id,
                manager_id: UserService.getUser().id,
                currency_id: variables.defaults.currency_id,
                status_id: variables.defaults.interest_status_id,
            };

            if ($stateParams.client) {
                api('clients')
                    .get($stateParams.client)
                    .then((response) => {
                        $scope.clientOptions.push({
                            id: response.id,
                            name: response.name,
                        });
                        $scope.interest.client_id = $stateParams.client;
                    });
            }
        }

        $scope.statusOptions = [];
        api('dictionaries/interest_phases')
            .selectize()
            .then((response) => {
                $scope.statusOptions = response.data;
            });

        $scope.userOptions = [];
        api('users')
            .selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } })
            .then((response) => {
                $scope.userOptions = response.data;
            });

        $scope.currencyOptions = [];
        api('dictionaries/currencies')
            .selectize()
            .then((response) => {
                $scope.currencyOptions = response.data;
            });

        $scope.woodworkOptions = [];
        api('dictionaries/woodwork')
            .selectize()
            .then((response) => {
                $scope.woodworkOptions = response.data;
            });

        $scope.interestLossOptions = [];
        api('dictionaries/interest_loss')
            .selectize()
            .then((response) => {
                $scope.interestLossOptions = response.data;
            });

        // form validation
        const fv = formValidator('#InterestForm', $scope);

        $scope.saveInterest = () => {
            if (!fv.isValid()) {
                return;
            }

            const redirectAfterSave = 0 == $scope.interest.id;
            const info = notify.info($translate.instant('saving'));
            notify.global(1);

            InterestModel.save($scope.interest.id, $scope.interest).then((response) => {
                $scope.interest = response;
                InterestModel.clearCache();

                info.close();
                notify.success($translate.instant('saved'));
                notify.global(0);
                $rootScope.$broadcast('edit-panel-ready');

                if (redirectAfterSave) {
                    $state.go('restricted.interests_edit', { id: $scope.interest.id });
                }
            });
        };

        $scope.showWhenLost = () => $scope.interest.status_id == variables.defaults.interest_loss_id;

        $scope.showWhenWon = () => $scope.interest.status_id == variables.defaults.interest_win_id;

        $scope.addProject = () => {
            $scope.interest.related_projects.push({});
        };

        $scope.removeProject = (i) => {
            $scope.interest.related_projects.splice(i, 1);
        };
    });
